import {useFormContext} from '@yandex-delivery/form'
import {useEffect, useMemo, useRef} from 'react'

import type {DeliveryInterval, Order} from 'src/shared/types'

import {mapDeliveryIntervals} from '../../DeliveryIntervalsNdd/utils'

const setFieldOptions = {
  shouldDirty: false,
  shouldTouch: false,
  shouldValidate: false,
}

export function useDeliveryIntervals() {
  const previousDate = useRef<string>()

  const {watch, setFieldValue} = useFormContext<Order>()

  const deliveryDate = watch('offerFlow.deliveryDate')
  const deliveryIntervals = watch('offerFlow.vertical.deliveryIntervals')

  const deliveryIntervalsMap = useMemo(() => {
    if (deliveryIntervals === undefined) {
      return {}
    }

    return mapDeliveryIntervals(deliveryIntervals)
  }, [deliveryIntervals])

  const dateList = useMemo<Array<string>>(() => {
    return Object.keys(deliveryIntervalsMap)
  }, [deliveryIntervalsMap])

  const intervalList = useMemo<Array<DeliveryInterval>>(() => {
    if (deliveryDate === undefined) {
      return []
    }

    const intervals = deliveryIntervalsMap[deliveryDate]

    return intervals || []
  }, [deliveryDate, deliveryIntervalsMap])

  // Первая дата для выбранного интервала
  const firstDate = dateList[0]

  // Первый интервал для выбранной даты
  const firstInterval = deliveryDate ? deliveryIntervalsMap[deliveryDate]?.[0] : undefined

  // Рендер, когда дата не установлена по умолчанию
  useEffect(() => {
    if (deliveryDate) return

    setFieldValue('offerFlow.deliveryDate', firstDate, setFieldOptions)
    setFieldValue('offerFlow.deliveryInterval', firstInterval, setFieldOptions)

    previousDate.current = firstDate
  }, [deliveryDate, firstDate, firstInterval, setFieldValue])

  // Рендер, когда меняем дату, меняется и интервал
  useEffect(() => {
    if (previousDate.current === deliveryDate) return

    setFieldValue('offerFlow.deliveryInterval', firstInterval, setFieldOptions)
    previousDate.current = deliveryDate
  }, [deliveryDate, firstInterval, setFieldValue])

  return {
    dateList,
    intervalList,
  }
}
